import React from 'react';
import {
  GitBranch,
  HelpCircle,
  CheckCircle,
  FileText,
  Code2,
  Bug,
  ListTodo,
  Box,
  Palette,
  Package,
  Shield
} from 'lucide-react';

const tools = [
  { name: 'GitLab', icon: GitBranch, color: 'bg-orange-500' },
  { name: 'Jira', icon: CheckCircle, color: 'bg-blue-500' },
  { name: 'Stack Overflow', icon: HelpCircle, color: 'bg-orange-400' },
  { name: 'Confluence', icon: FileText, color: 'bg-blue-600' },
  { name: 'SonarQube', icon: Code2, color: 'bg-blue-400' },
  { name: 'Sentry', icon: Bug, color: 'bg-purple-600' },
  { name: 'Asana', icon: ListTodo, color: 'bg-red-500' },
  { name: 'CNX', icon: Box, color: 'bg-gray-600' },
  { name: 'Figma', icon: Palette, color: 'bg-purple-500' },
  { name: 'Artifactory', icon: Package, color: 'bg-green-600' },
  { name: 'Wiz', icon: Shield, color: 'bg-blue-700' },
];

export const DeveloperTools: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-4">Developer Tools</h2>
      <div className="grid grid-cols-6 gap-4">
        {tools.map((tool) => {
          const Icon = tool.icon;
          return (
            <button
              key={tool.name}
              className="flex flex-col items-center justify-center p-4 hover:bg-gray-50 rounded-lg transition-colors"
            >
              <div className={`w-12 h-12 ${tool.color} rounded-lg flex items-center justify-center text-white mb-2`}>
                <Icon className="w-6 h-6" />
              </div>
              <span className="text-xs text-gray-700">{tool.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};